import { Button } from '@creditornot/cb-button';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import GuyMirror from 'common/illustrations/GuyMirror';
import { Typography as T } from 'common/typography';

import { SectionConfigurationContext } from './SectionConfigurationContext';
import { useKybNavigation } from './useKybNavigation';
import { CenteredContent, Heading, IllustrationContainer, TextStack } from '../ComplianceContent';
import { BREAKPOINT_MOBILE } from '../breakpoints';

const StyledBody = styled(T.Body1)`
  text-align: center;
  max-width: 600px;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (min-width: ${BREAKPOINT_MOBILE}px) {
    max-width: 200px;
  }
`;

const BusinessVerificationIntro = () => {
  const { navigate } = useKybNavigation();
  const sectionConfig = useContext(SectionConfigurationContext);
  const firstSection = sectionConfig.enabledSections[0] ?? 'basic-info';

  const handleGetStarted = () => {
    navigate(`/flow/${firstSection}`);
  };

  return (
    <CenteredContent>
      <IllustrationContainer>
        <GuyMirror height="100%" />
      </IllustrationContainer>

      <TextStack>
        <Heading>
          <FormattedMessage id="compliance.kyb.verify-intro.heading" />
        </Heading>

        <StyledBody>
          <FormattedMessage id="compliance.kyb.verify-intro.body" />
        </StyledBody>
      </TextStack>

      <ActionsContainer>
        <Button size="large" variant="primary" onClick={handleGetStarted}>
          <FormattedMessage id="compliance.kyb.verify-intro.get-started" />
        </Button>
      </ActionsContainer>
    </CenteredContent>
  );
};

export default BusinessVerificationIntro;
